import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const CRMDashboard = lazy(() => import('./pages/CRMDashboard'));
const CustomerList = lazy(() => import('./pages/CustomerList'));
const RequestList = lazy(() => import('./pages/RequestList'));
const QuickRequest = lazy(() => import('./pages/QuickRequestNew'));
const RequestView = lazy(() => import('./pages/RequestViewNew'));
const CrmResultsPage = lazy(() => import('./pages/CrmResultsPage'));

const crmRoutes: RouteObject[] = [
  {
    index: true,
    element: <CRMDashboard />,
  },
  {
    path: 'customers',
    element: <CustomerList />,
  },
  {
    path: 'requests',
    element: <RequestList />,
  },
  {
    path: 'requests/quick',
    element: <QuickRequest />,
  },
  {
    path: 'requests/:id',
    element: <RequestView />,
  },
  {
    path: 'results',
    element: <CrmResultsPage />,
  },
];

export default crmRoutes;
